import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";
import { modelAGF } from "../hooks/useModel";

const InvestmentChart = () => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    // Вычисляем данные для площадей от 700 до 2500 с шагом 100
    const areas = [];
    const investments = [];
    for (let s = 700; s <= 2500; s += 100) {
      // Параметры по умолчанию: аренда 0, кредит 0, ставка 0, срок 0, амортизация false, ключевая ставка 17%
      const m = modelAGF(s, 0, 0, 0, 0, false, 0.17);
      areas.push(s);
      investments.push(m.sumInvestments);
    }

    if (chartInstance.current) chartInstance.current.destroy();

    chartInstance.current = new Chart(chartRef.current, {
      type: "bar",
      data: {
        labels: areas,
        datasets: [
          {
            label: "Сумма вложений",
            data: investments,
            borderWidth: 2,
            borderColor: "black",
            backgroundColor: "rgba(0,0,0,0.2)",
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          title: {
            display: true,
            text: "Сумма вложений от площади помещения",
            font: {
              family: "Montserrat, sans-serif",
              size: 16,
              weight: "bold",
            },
          },
          legend: { display: false },
        },
        scales: {
          y: {
            beginAtZero: true,
            title: { display: true, text: "Сумма вложений, руб" },
            ticks: {
              callback: (val) => val.toLocaleString("ru-RU"),
            },
          },
          x: {
            title: { display: true, text: "Площадь помещения, м²" },
          },
        },
      },
    });

    return () => {
      if (chartInstance.current) chartInstance.current.destroy();
    };
  }, []);

  return (
    <canvas ref={chartRef} style={{ width: "100%", maxHeight: "400px" }} />
  );
};

export default InvestmentChart;
